<template>
  <a-spin class="map-spinning" :spinning="mapSpinning">
    <div style="position:relative">
      <div
      class="svg"
      ref="svgObject"></div>
      <div
      v-if="merchantInfo.isShowModal"
      class="shopinfo-modal"
      :style="{left: transformX + 'px', top: transformY + 'px'}">
        <div class="bd">
          <div class="name">{{merchantInfo.companyName}}</div>
          <div class="pic1">
            <img class="img" :src="merchantInfo.headerPic" @click="showHeaderPic" />
          </div>
          <div class="item">经营范围：{{merchantInfo.jyScope}}</div>
          <div class="item">店铺介绍：{{merchantInfo.shopIntroduce}}</div>
          <div class="item addr">店铺地址：{{merchantInfo.shopAddr}}</div>
          <div class="item">联系电话：{{merchantInfo.phone}}</div>
        </div>
        <div class="ydym" v-if="merchantInfo.ydymStatus === 1">该商家已开通品牌图册，使用微信扫一扫查看</div>
        <div class="ydym" v-else>该商家暂未开通品牌图册<a class="show-ydymdtl" href="https://img.huahuabiz.com/PC/static/mini-program/yudian-code-web.html" target="_blank">了解品牌图册</a></div>
        <div class="pic2" v-if="merchantInfo.ydymStatus === 1">
          <img v-if="sunCodeUrl" class="img" :src="sunCodeUrl" />
          <a-icon v-else type="loading" />
        </div>
        <div class="pic2" v-else>
          <img class="img" src="@/assets/suncode.png" />
        </div>
        <div class="jt"></div>
        <div class="close" @click="closeMerchantModal"><a-icon type="close-circle" /></div>
      </div>
      <div
      class="no-merchant"
      v-if="noMerchant.isShowModal"
      :style="{left: transformX + 'px', top: transformY + 'px'}">
        <img src="@/assets/no-merchant.png" />
        <div class="jt"></div>
        <div class="close" @click="closeNoMerchantModal"><a-icon type="close-circle" /></div>
      </div>
    </div>

    <div v-if="visible" class="headerpic-modal">
      <div class="bg"></div>
      <div class="bd">
        <img class="img" :src="merchantInfo.headerPic" />
      </div>
      <div class="close" @click="closeModal">×</div>
    </div>
  </a-spin>
</template>

<script>
import { getAction } from '@/api/http'
import * as d3 from 'd3'
import $ from 'jquery'
import {commonMixin} from '@/mixins/commonMixin'
export default {
  name: 'Index',
  mixins: [commonMixin],
  props: ['pW', 'pH'],
  data () {
    return {
      visible: false,
      mapSpinning: false,
      zoom_: null,
      container: null,
      transformX: 0,
      transformY: 0,
      dX: 0,
      dY: 0,
      disX: 0,
      disY: 0,
      curEle: null,
      curRoomNo: '',
      clickX: 0,
      clickY: 0,
      scale: 1
    }
  },
  computed: {
    roomNo () {
      return this.$store.state.roomNo
    },
    merchantInfo () {
      return this.$store.state.merchantInfo
    },
    noMerchant () {
      return this.$store.state.noMerchant
    },
    sunCodeUrl () {
      return this.$store.state.sunCodeUrl
    }
  },
  methods: {
    resetData () {
      this.mapSpinning = false,
      this.zoom_ = null,
      this.container = null,
      this.transformX = 0,
      this.transformY = 0,
      this.dX = 0,
      this.dY = 0,
      this.disX = 0,
      this.disY = 0,
      this.curEle = null,
      this.curRoomNo = '',
      this.clickX = 0,
      this.clickY = 0,
      this.scale = 1
    },
    // 显示门头图的大图
    showHeaderPic () {
      this.visible = true
    },
    // 关闭门头图的大图
    closeModal () {
      this.visible = false
    },
    // 关闭弹窗后还原当前房间的颜色
    reBackCurRoomColor (curEle) {
      const roomrid = curEle.attr('id')
      const $curRoom = $('[id ^= "' + roomrid + '"]')
      const dataRoomid = $curRoom.data('roomid')
      const curText = $curRoom.children('text')
      const curgEle = curText.siblings('g')
      const curRect = $curRoom.children('rect')
      const curFill = curgEle.length > 0 ? curgEle : curRect
      if (dataRoomid) {
        curFill.css('fill', '#DFE8EE')
        curText.css('fill', '#47799C')
      } else {
        curFill.css('fill', '#EFECEB')
        curText.css('fill', '#333333')
      }
    },
    // 关闭商家信息弹窗
    closeMerchantModal () {
      const that = this
      const curEle = that.curEle
      const obj = Object.assign({}, that.merchantInfo, {isShowModal: false})
      that.$store.commit('setMerchantInfo', obj)
      if (curEle && curEle.node()){
        that.reBackCurRoomColor(curEle)
      }
    },
    // 显示商家信息弹窗
    showMerchantModal () {
      const that = this
      const obj = Object.assign({}, that.merchantInfo, {isShowModal: true})
      that.$store.commit('setMerchantInfo', obj)
    },
    // 关闭暂无信息弹窗
    closeNoMerchantModal () {
      const that = this
      const curEle = that.curEle
      const obj = Object.assign({}, that.noMerchant, {isShowModal: false})
      that.$store.commit('setNoMerchant', obj)
      if (curEle && curEle.node()){
        that.reBackCurRoomColor(curEle)
      }
    },

    // 显示暂无信息弹窗
    showNoMerchantModal () {
      const that = this
      const obj = Object.assign({}, that.noMerchant, {isShowModal: true})
      that.$store.commit('setNoMerchant', obj)
      console.log('showNoMerchantModal')
    },

    clickMerchant () {
      const that = this
      that.init(that.rendRoom)
    },

    // 根据商家id和房间id获取对应房间的商家信息
    getMerchantInfo (companyId, roomId, roomRid) {
      const that = this
      const cityId = that.$store.state.cityId
      const projectId = that.$store.state.projectId
      const floorId = that.$store.state.floorId
      getAction('/shop/queryComInfoById', {
        cityId,
        projectId,
        floorId,
        companyId,
        roomId
      }).then((res) => {
        if (res.code === '1') {
          const result = res.data
          that.$store.commit('setMerchantInfo', {
            id: result.companyId,
            companyName: result.companyName,
            headerPic: that.$fileUrl + result.authPic,
            jyScope: result.businessScope,
            shopIntroduce: result.mainProducts,
            shopAddr: result.cityName + result.projectName + result.floorName + result.roomNo,
            phone: result.isShow === 1 ? result.showPhone : '',
            ydymStatus: result.isMa
          })
          that.showMerchantModal()
          if (result.isMa) {
            that.getWxEwm([roomRid])
          }
        } else {
          that.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        that.$message.error('查询失败')
      })
    },

    // 设置房间的颜色
    setHouseColor (curEle) {
      const that = this
      const roomInfoArry = that.$store.state.roomInfoArry

      // 获取所有房源的信息
      const houseItem = $('*[id ^= "R"]')
      const houseText = houseItem.children('text')
      const houseG = houseText.siblings('g')
      const houseRect = houseItem.children('rect')
      const houseFill = houseG.length > 0 ? houseG : houseRect
      
      // 设置每个房间鼠标放上去的时候为手指形状
      houseItem.css('cursor','pointer')

      // 将所有的房间设置成默认色系
      houseFill.css('fill', '#EFECEB').css('stroke', '#fff')
      houseText.css('fill', '#333333')
      houseG.find('path[fill]').attr('fill', '#fff') // 此代码主要是修改华强辅料行所在的楼层地图的房间的多余灰色线条

      // 将已入驻房源色差已入驻色系
      for (let item of roomInfoArry.values()) {
        const curItem = $('*[id^="'+item.roomRid+'"]')
        const subText = curItem.children('text')
        const subgEle = subText.siblings('g')
        const rectEle = curItem.children('rect')
        const fillEle = subgEle.length > 0 ? subgEle : rectEle

        curItem.attr('data-companyid', item.companyId)
        curItem.attr('data-roomid', item.roomId)
        
        fillEle.css('fill', '#DFE8EE')
        subText.css('fill', '#47799C')
      }

      // 将点击房源色差焦点色系
      if (curEle) {
        const curText = curEle.children('text')
        const curgEle = curText.siblings('g')
        const curRect = curEle.children('rect')
        const curFill = curgEle.length > 0 ? curgEle : curRect
        curFill.css('fill', '#47799C')
        curText.css('fill', '#fff')
      }
    },

    /**
     * 点击房间
     */
    clickRoom () {
      const that = this
      d3.selectAll('[id^="R"]').on('click', function(){
        const scale = that.scale
        const curEle = d3.select(this)
        const companyId = curEle.attr('data-companyid')
        const roomid = curEle.attr('data-roomid')
        const roomrid = curEle.attr('id')
        const $curRoom = $('[id ^= "' + roomrid + '"]')
        const gEle = d3.select('#FloorPlan')
        const gEleClientRects = gEle.node().getBoundingClientRect()
        const gX = gEleClientRects.left
        const gY = gEleClientRects.top
        const curClientRects = curEle.node().getBoundingClientRect()
        const curX = curClientRects.left + curClientRects.width/2 - gX
        const curY = curClientRects.top - gY

        // 记录点击事件,取R开头的唯一房间编号
        window.sendEvent("pc-guide-merchant-room-click", {roomId: roomrid, merchantId: companyId})

        that.curEle = curEle
        that.transformX = that.dX + curX + that.disX * that.scale
        that.transformY = that.dY + curY + (scale >= 1 ? that.disY * scale : that.disY * scale/2)
        if (companyId) {
          // 刚点击的时候初始先隐藏弹窗，等数据都加载下来后再显示弹窗,并将太阳码设为空
          that.closeNoMerchantModal()
          that.closeMerchantModal()
          that.$store.commit('setSunCodeUrl', '')
          that.getMerchantInfo(companyId, roomid, roomrid)
        } else {
          that.closeMerchantModal()
          that.showNoMerchantModal()
          that.$store.commit('setMerchantInfo', {})
        }

        that.setHouseColor($curRoom)
      })
    },

    rendRoom () {
      const that = this
      that.scale = 1
      that.container.attr("transform","scale(" + that.scale + ")")// 默认先将svg大小还原为默认大小，然后在进行下面的操作
      const roomNoArry = that.roomNo || []
      const gEle = d3.select('#FloorPlan')
      const gEleClientRects = gEle.node().getBoundingClientRect()
      const gX = gEleClientRects.left
      const gY = gEleClientRects.top
      that.closeNoMerchantModal() // 先关闭弹窗
      if (roomNoArry.length > 0) {
        that.curRoomNo = roomNoArry[0]
        const $curRoom = $('[id ^= "' + that.curRoomNo + '"]')
        const curEle = d3.selectAll('[id^="'+that.curRoomNo+'"]')
        const subgEle = curEle.select('g')
        if (!curEle.node()) {
          that.$message.error('该商家在该楼层没有对应的房号，请切换楼层')
          that.closeMerchantModal()
          return
        }

        that.curEle = curEle
        const curClientRects = curEle.node().getBoundingClientRect()
        const curX = curClientRects.left + curClientRects.width - gX
        let curY = curClientRects.top + curClientRects.height - gY

        that.clickX = -curX + that.pW / 2 + curClientRects.width
        that.clickY = -curY + that.pH / 2 + curClientRects.height

        if (!subgEle._groups[0][0]) {
          that.clickX = -curX + that.pW / 2
          that.clickY = -curY + that.pH / 2
        }

        that.dX = that.clickX
        that.dY = that.clickY

        that.container.attr(
          "transform",
          "translate(" +
          that.clickX +
          "," +
          that.clickY +
          ")scale(" +
          1 +
          ")"
        )

        that.transformX = that.pW / 2 + curClientRects.width/2
        that.transformY = that.pH / 2
        that.showMerchantModal()
        that.setHouseColor($curRoom)
      }
    },

    // 放大缩小及移动
    zoomed () {
      const that = this
      const x = d3.event.transform.x + that.clickX
      const y = d3.event.transform.y + that.clickY
      const k = d3.event.transform.k

      that.dX = x
      that.dY = y
      that.scale = k

      that.container.attr(
        "transform",
        "translate(" +
        x +
        "," +
        y +
        ")scale(" +
        k +
        ")"
      )

      if (that.merchantInfo.isShowModal || that.noMerchant.isShowModal) {
        const gEle = d3.select('#FloorPlan')
        const gEleClientRects = gEle.node().getBoundingClientRect()
        const gX = gEleClientRects.left
        const gY = gEleClientRects.top
        const curEle = that.curEle
        const curClientRects = curEle.node().getBoundingClientRect()
        const curX = curClientRects.left + curClientRects.width/2 - gX
        const curY = curClientRects.top - gY

        that.transformX = x + curX + that.disX * k
        that.transformY = y + curY + (k >= 1 ? that.disY * k : that.disY * k/2)
      }

    },

    // 初始化
    init (callBack) {
      const that = this
      const svgUrl = that.$store.state.svgUrl
      that.resetData() // 首先重置


      that.mapSpinning = true
      
      d3.xml(svgUrl).then(data => {

        d3.select('.svg svg').remove() // 先删除地图

        d3.select('.svg')
        .node()
        .append(data.documentElement)

        that.container = d3.select('#FloorPlan')

        // 获取初始svg 和 floorPlan之间的距离
        const svgEle = d3.select('.svg svg')
        const svgEleClientRects = svgEle.node().getBoundingClientRect()
        const svgX = svgEleClientRects.left
        const svgY = svgEleClientRects.top
        const gEle = d3.select('#FloorPlan')
        const gEleClientRects = gEle.node().getBoundingClientRect()
        const gX = gEleClientRects.left
        const gY = gEleClientRects.top
        that.disX = gX - svgX
        that.disY = gY - svgY

        // svg放大缩小及移动相关操作
        that.zoom_ = d3.zoom().scaleExtent([0.2, 3]).on("zoom", that.zoomed)
        d3.select('.svg svg').call(that.zoom_)

        // 设置房间相关信息
        if (typeof callBack === 'function') {
          callBack()
        } else {
          that.setHouseColor()
        }

        // 点击房间相关的事件
        that.clickRoom()

        that.mapSpinning = false
      })
    }
  }
}
</script>

<style>
.second-yt .ant-col-16{width: 100%;}
</style>
<style scoped>
.map-spinning{min-height: 600px;}
.svg{cursor: pointer;text-align: left;}
.shopinfo-modal{position: absolute;top: 20px;background-color: #fff;width: 520px;height: 315px;box-sizing: border-box;border: 5px solid #F4CF89;border-radius: 20px;font-size: 12px;color: #333;padding: 10px;text-align: left;margin-left: -260px;margin-top: -315px;}
.shopinfo-modal .bd{width: 495px;height: 230px;margin-left: auto;margin-right: auto;overflow: auto;}
.shopinfo-modal .bd::-webkit-scrollbar {/*滚动条整体样式*/
  width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
.shopinfo-modal .bd::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 5px;
  background: #999;
}
.shopinfo-modal .bd::-webkit-scrollbar-track {/*滚动条里面轨道*/
  border-radius: 5px;
  background: #E5E5E5;
}
.shopinfo-modal .name{font-size: 14px;font-weight: bold;}
.shopinfo-modal .addr{width: 365px;}
.shopinfo-modal .pic1{width: 250px;display: flex;margin-top: 5px;margin-bottom: 8px;}
.shopinfo-modal .pic1 .img{max-width: 250px;max-height: 90px;}
.shopinfo-modal .item{margin-top: 5px;}
.shopinfo-modal .ydym,.shopinfo-modal .pic2{position: absolute;right: 20px;bottom: 10px;z-index: 10;}
.shopinfo-modal .ydym{border: 1px solid #ddd;border-radius: 50px 0 0 0;padding: 10px 25px;left: 10px;}
.shopinfo-modal .pic2{background-color: #fff;width: 100px;height: 100px;display: flex;justify-content: center;align-items: center;border: 1px solid #ddd;}
.shopinfo-modal .pic2 .img{max-width: 100px;max-height: 100px;}
.shopinfo-modal .jt,.no-merchant .jt{position: absolute;left: 50%;margin-left: -10px;font-size: 0;line-height: 0;}
.shopinfo-modal .jt{bottom: -15px;border-width: 10px;border-color: #F4CF89;border-bottom-width: 0;border-style: dashed;border-top-style: solid;border-left-color: transparent;border-right-color: transparent;}
.no-merchant .jt{bottom: -10px;border-width: 10px;border-color: #fff;border-bottom-width: 0;border-style: dashed;border-top-style: solid;border-left-color: transparent;border-right-color: transparent;}
.shopinfo-modal .show-ydymdtl{color: #1890ff;margin-left: 10px;}
.shopinfo-modal .close,.no-merchant .close{position: absolute;color: #999;right: 20px;top: 5px;font-size: 20px;cursor: pointer;}
.shopinfo-modal .close:hover,.no-merchant .close:hover{color: #1890ff;}
.no-merchant{position: absolute;background-color: #fff;box-shadow: 0 0 10px rgba(0,0,0,0.3);width: 268px;height: 168px;margin-left: -134px;margin-top: -168px;}

.headerpic-modal{z-index: 100001;}
.headerpic-modal,.headerpic-modal .bg,.headerpic-modal .bd,.headerpic-modal .close{position: fixed;}
.headerpic-modal,.headerpic-modal .bg,.headerpic-modal .bd{left: 0;top: 0;right: 0;bottom: 0;}
.headerpic-modal .bg{background-color: #000;opacity: 0.8;}
.headerpic-modal .bd,.headerpic-modal .close{display: flex;justify-content: center;align-items: center;}
.headerpic-modal .bd .img{max-width: 100%;max-height: 100%;}
.headerpic-modal .close{color: #999;top: 20px;right: 15px;background-color: #fff;width: 30px;height: 30px;border-radius: 15px;cursor: pointer;font-size: 35px;overflow: hidden;}
</style>
